import { setContext, setUser } from '@sentry/vue';
import { configs } from '../configs';
import { storageService } from './storageService';

export const authService = {
  getAuthToken(): string | null {
    return storageService.session.get(configs.AUTH_TOKEN);
  },
  setAuthToken(jwtToken: string) {
    storageService.session.set(configs.AUTH_TOKEN, jwtToken);
  },
  // if logged in via SSO, copy the SSO token to auth user
  setControlledModeToken() {
    const token = storageService.session.get(configs.CONTROLLED_MODE_AUTH_TOKEN);

    if (token) {
      this.setAuthToken(token);
    }
  },
  setSessionId(sessionId: string) {
    storageService.session.set(configs.SESSION_ID_KEY, sessionId);
    setUser({ id: sessionId });
  },
  getSessionId(): string | undefined {
    return storageService.session.get(configs.SESSION_ID_KEY);
  },
  logout() {
    storageService.session.clear();
    this.resetSSOAuth();
  },
  resetSSOAuth() {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('CognitoIdentityServiceProvider.')) {
        localStorage.removeItem(key);
      }
    });
  },
  setControlledMode() {
    storageService.session.set(configs.CONTROLLED_MODE_KEY, true);
    setContext('controlledMode', { controlledMode: true });
    this.setControlledModeToken();
  },
  isControlledMode(): boolean {
    return !!storageService.session.get(configs.CONTROLLED_MODE_KEY);
  },
  isLoggedIn(): boolean {
    return this.isControlledMode() || !!this.getAuthToken();
  },
};
